const resolveSingleSelectionProductIds = (entry, searchHit) => {
  if (!entry) return {};

  if (entry.type === 'master') {
    return { productId: entry._id };
  }
  if (entry.type === 'masterVariant') {
    return { productId: entry.baseProductId, variantId: entry._id };
  }
  if (entry.type === 'listing') {
    return { productId: entry.masterProductId };
  }
  if (entry.type === 'listingVariant') {
    const variantId = entry.masterVariantId || searchHit?.masterVariantId;
    return {
      productId: entry.masterProductId || searchHit?.masterProductId,
      ...(variantId ? { variantId } : {}),
    };
  }

  return {};
};

export default resolveSingleSelectionProductIds;
